// Imports libraries
import React from "react";
import { Link, useNavigate } from "react-router-dom";

import locale_resources from "../locale/resources.json";

import { Resources, isAdmin } from "../utils";

// Imports components
import Card from "../components/atoms/card";
import Spacer from "../components/atoms/spacer";
import Top from "../components/organisms/top";
import Bottom from "../components/organisms/bottom";

// Imports models
import { database as db } from "../../index";
import { collection, doc, getDoc } from "firebase/firestore";

// Imports locales
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-hot-toast";
import Row from "../components/atoms/row";
import Column from "../components/atoms/column";

const openResource = () => {
    if (window.innerWidth >= "1000"){
        document.getElementById("sidebarResource").style.width = "40vw";
        document.getElementById("sidebarResource").style.paddingLeft = "15px";
    } else {
        document.getElementById("sidebarResource").style.width = "90vw";
        document.getElementById("sidebarResource").style.paddingLeft = "15px";
    }
    document.getElementById("sidebarResource").style.overflowY = "scroll";
    document.getElementById("add").style.display = "none";
}

const openCategory = () => {
    if (window.innerWidth >= "1000"){
        document.getElementById("sidebarCategory").style.width = "40vw";
        document.getElementById("sidebarCategory").style.paddingLeft = "15px";
    } else {
        document.getElementById("sidebarCategory").style.width = "90vw";
        document.getElementById("sidebarCategory").style.paddingLeft = "15px";
    }
    document.getElementById("sidebarCategory").style.overflowY = "scroll";
}

const closeResource = () => {
    document.getElementById("sidebarResource").style.width = "0vw";
    document.getElementById("sidebarResource").style.paddingLeft = "0px";
    document.getElementById("sidebarResource").style.overflowY = "hidden";
}

const closeCategory = () => {
    document.getElementById("sidebarCategory").style.width = "0vw";
    document.getElementById("sidebarCategory").style.paddingLeft = "0px";
    document.getElementById("sidebarCategory").style.overflowY = "hidden";
}

export default
function ResourcesPage
(props)
{
    const id = props.id;
    const navigate = useNavigate();
    const [coach, setCoach] = useState({});
    const [categoriesData, setCategoriesData] = useState([]);
    const [resourcesData, setResourcesData] = useState([]);

    const [newResourceName, setNewResourceName] = useState("");
    const [newResourceLink, setNewResourceLink] = useState("");
    const [newResourceCategory, setNewResourceCategory] = useState("");
    const [newCategoryName, setNewCategoryName] = useState("");

    const resourcesHandler = new Resources();

    useEffect(() => {
        (async () => {
            const cLOC = doc(collection(db, "Coaches"), id);
            const cDOC = await getDoc(cLOC);
            setCoach(cDOC.data());
        })();
    }, [id]);
    
    const fetchData = async () => {

        const fetchedCategories = await resourcesHandler.getCategories();
        if (fetchedCategories) {
            setCategoriesData(fetchedCategories);
        }

        const fetchedResources = await resourcesHandler.getResources();
        if (fetchedResources) {
            setResourcesData(fetchedResources);
        }

    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <React.Fragment>

            <div id="sidebarResource" className="sidebar">
                <a onClick={closeResource} className="close">&times;</a>
                <div className="side_section" id="manual_setup">
                    <h2>Create New Resource</h2>
                    <Spacer/>
                    <label htmlFor="resource_name">Resource name</label>
                    <input type="text" id="resource_name" value={newResourceName} onChange={(event) => setNewResourceName(event.target.value)} placeholder="Please type here..." /><p></p>
                    <label htmlFor="resource_link">Resource link</label>
                    <input type="text" id="resource_link" value={newResourceLink} onChange={(event) => setNewResourceLink(event.target.value)} placeholder="Please enter link here..." /><p></p>
                    <p>The resource link must start with https:// for external websites</p>
                    <label htmlFor="resource_category">Select Category</label>
                    <select id="resource_category" value={newResourceCategory} onChange={(event) => setNewResourceCategory(event.target.value)}>
                        <option>Select a category...</option>
                        {categoriesData.map((cat) => (
                            <option key={cat} value={cat}>
                                {cat}
                            </option>
                        ))}
                    </select>
                </div>
                <button 
                    className="primary" 
                    id="new_resource" 
                    onClick={async () => {

                        const title = newResourceName.trim();
                        const link = newResourceLink.trim();
                        const category = newResourceCategory.trim();

                        if (!(title && link && category)) {
                            toast.error("Please complete all fields.");
                            return;
                        }

                        await resourcesHandler.addResource(category, title, link, coach.email_address);
                        closeResource();
                        fetchData();
                    }}
                >
                    Create
                </button> 
                <Spacer /><Spacer />
            </div>

            <div id="sidebarCategory" className="sidebar">
                <a onClick={closeCategory} className="close">&times;</a>
                <div className="side_section" id="manual_setup">
                    <h2>Create New Category</h2>
                    <Spacer />
                    <label htmlFor="category_name">Category name</label>
                    <input type="text" id="category_name" value={newCategoryName} onChange={(event) => setNewCategoryName(event.target.value)} placeholder="Please type here..." /><p></p>
                </div>
                <button 
                    className="primary" 
                    id="new_category" 
                    onClick={async () => {
                        const categoryName = newCategoryName.trim();
                        if (!(categoryName)) {
                            toast.error("Please complete all fields.");
                            return;
                        }
                        await resourcesHandler.addCategory(categoryName, coach.email_address);
                        closeCategory();
                        fetchData();
                    }}
                >
                   Create
                </button> 
                <Spacer /><Spacer />
            </div>


             <Top id="Hello" title="Resources" hero="">
                <button className="accent space" id="home" onClick={() => navigate("/")}>Home</button>
            </Top>

            <Spacer />
            
            <main>
                {isAdmin(coach.email_address) && (
                    <section className="container">
                        <div className="gap-bottom buttons-container">
                            {resourcesData.length > 0 && <button className="accent" onClick={openResource}>
                                Create New Resource
                            </button>}
                            <button className="accent" onClick={openCategory}>
                                Create New Category
                            </button>
                        </div>
                        <Spacer />
                    </section>
                )}

                <section className="container resources">
                    <Row><Column size="100" side="left">
                    {resourcesData.map((resource, index) => (
                        <details key={index}>
                            <summary>{resource.name}</summary>
                            <hr />
                            <div className="category">
                                {resource.items.length > 0 ? resource.items.map(item => (
                                    <div key={item.id} className="resourcee">
                                        <h3>{item.name}</h3>
                                        <a href={item.link} target="_blank" rel="noreferrer">
                                            <button className="views accent">View</button>
                                        </a>
                                        {isAdmin(coach.email_address) && <div>
                                            <button className="views primary" onClick={() => {
                                                resourcesHandler.popResource(resource.name, item.name, coach.email_address);
                                                fetchData();
                                            }}>Delete Resource</button>
                                        </div>}
                                    </div>
                                )) : <p>No resources available yet in this category</p>}
                            </div>
                            {isAdmin(coach.email_address) && <div>
                                <button className="views primary" onClick={() => {
                                    resourcesHandler.popCategory(resource.name, coach.email_address);
                                    fetchData();
                                }}>Delete Category</button>
                            </div>}
                        </details>
                    ))}
                    </Column></Row>
                </section>

            </main>

            <Spacer />

            <Bottom />
        </React.Fragment>
    );
}